// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/stylesheets/components/foldout.scss
// module id = 426
// module chunks = 0